import { Box, BoxProps, Group, MantineSize, Text } from '@mantine/core';
import classNames from 'classnames';

import styles from './LabelText.module.scss';

export interface LabelTextProps {
  label: string;
  size?: MantineSize;
  icon?: React.ReactNode;
  onIconClick?: () => void;
  className?: string;
  variant?: 'regular' | 'allCaps' | 'sentence';
  required?: boolean;
  boxProps?: BoxProps;
}

const LabelText = ({
  label,
  icon,
  onIconClick,
  className,
  variant = 'allCaps',
  size,
  required = false,
  boxProps
}: LabelTextProps) => {
  return (
    <Box {...boxProps} mb={2}>
      <Text size={size ?? 'sm'} className={classNames(styles.text, className, styles[variant])}>
        <Group gap={4}>
          {label}
          {required && <span className={styles.requiredIndicator}>*</span>}
          {icon && (
            <span onClick={onIconClick} className={styles.icon}>
              {icon}
            </span>
          )}
        </Group>
      </Text>
    </Box>
  );
};

export default LabelText;
